export const navbar_items = {
    "Map":"",
    "Analytics":"",
    "API Documentation":"",
}

export const footer_items = Object.assign({},navbar_items,{
    "Home": "",
    "About": "",
    "Timetable Source": "https://www.railwaydata.co.uk/timetables/glasgow/aug24/GlasgowSubwayTimetable.pdf",
    "Who Made This": "https://github.com/asimno",
})

export const extra_items = {
    "Github": "https://github.com/asimno/Glasgow-Subway-Predictor",
}